import React, { useState, useEffect } from "react";

const FORGE_MESSAGES = {
  "CE-01": [
    "Finding the words that make hearts race...",
    "Writing the silence between two glances...",
    "Crafting the moment everything changes...",
  ],
  "CE-02": [
    "Capturing the burst of pure light...",
    "Writing the laugh that echoes through every scene...",
    "Forging a moment worth celebrating...",
  ],
  "CE-03": [
    "Finding beauty in the weight of loss...",
    "Writing the tears that tell the truth...",
    "Crafting the ache that makes us human...",
  ],
  "CE-04": [
    "Sharpening every word to a blade's edge...",
    "Writing the fire that won't be contained...",
    "Forging rage into revelation...",
  ],
  "CE-05": [
    "Writing the stand that defines a hero...",
    "Forging courage from impossible odds...",
    "Crafting the moment fear becomes fuel...",
  ],
  "CE-06": [
    "Building the silence before the storm...",
    "Writing what lurks just out of frame...",
    "Crafting the moment your audience holds their breath...",
  ],
  "CE-07": [
    "Exposing what should stay hidden...",
    "Writing the truth that makes skin crawl...",
    "Forging disgust into dramatic power...",
  ],
  "CE-08": [
    "Unraveling a mystery, one word at a time...",
    "Writing the gasp that opens worlds...",
    "Crafting discovery from the unknown...",
  ],
  "CE-09": [
    "Finding peace in the final breath...",
    "Writing the calm after every storm...",
    "Crafting the resolution that heals...",
  ],
};

const DEFAULT_MESSAGES = [
  "Forging your scene...",
  "The ArcScript engine is crafting your story...",
  "Weaving emotion into every line...",
];

export function ForgeAnimation({ ce }) {
  const messages = FORGE_MESSAGES[ce] || DEFAULT_MESSAGES;
  const [msgIdx, setMsgIdx] = useState(0);
  const [msgVisible, setMsgVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setMsgVisible(false);
      setTimeout(() => {
        setMsgIdx(prev => (prev + 1) % messages.length);
        setMsgVisible(true);
      }, 300);
    }, 3000);
    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <div className="forge-container" data-testid="forge-animation">
      {/* Pen sweep track */}
      <div className="forge-track" aria-hidden="true">
        <div className="forge-trail" />
        <div className="forge-nib">
          <svg width="28" height="28" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Pen nib body */}
            <path d="M7 25 L25 7 L29 11 L11 29 Z" fill="var(--accent-gold)" />
            {/* Pen cap */}
            <path d="M25 7 L29 3 L29 11 Z" fill="var(--ink-primary)" opacity="0.7" />
            {/* Ink slit */}
            <line x1="9" y1="23" x2="23" y2="9" stroke="var(--surface-page)" strokeWidth="1.5" opacity="0.6" />
            {/* Ink drop */}
            <circle cx="8" cy="25" r="2.5" fill="var(--accent-gold)" opacity="0.6" />
          </svg>
        </div>
      </div>

      {/* Rotating message */}
      <p
        className="forge-message"
        style={{ opacity: msgVisible ? 1 : 0 }}
        aria-live="polite"
        data-testid="forge-message"
      >
        {messages[msgIdx]}
      </p>

      {/* Engine label */}
      <p className="forge-label">ArcScript Engine</p>
    </div>
  );
}
